import { gql } from "lib/apolloClient";
import { staffFragment, studentFragment } from "modules/CommonFragments";

export const aiFragment = {
  aiMessage: gql`
    fragment aiMessageItem on AiMessage {
      id
      role
      authorType
      content
      metadata
      severity
      createdBy {
        ...staffItem
        ...studentItem
      }
      votes {
        myVote
      }
      usageMetricsId
      parentMessage {
        id
      }
      createdAt
      attachments {
        id
        name
        type
        mimeType
        url
        thumbUrl
        signedUrl
        title
        metadata
        streamUrl
        parentType
        createdBy {
          id
          type
        }
        modalityAttachment {
          id
          ... on ToddleDoc {
            id
            content: value
          }
          ... on ModalityFile {
            id
            content
            metadata
          }
        }
        presetAttachment {
          id
        }
        createdAt
      }
    }
    ${staffFragment.basicStaffDetails}
    ${studentFragment.basicStudentDetails}
  `,
};
